import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import { ElMessage } from 'element-plus'
import { getToken } from '@/utils/auth'
import { isHttp } from '@/utils/validate'
import { isRelogin } from '@/utils/request'

NProgress.configure({ showSpinner: false });

// 白名单
const whiteList = ['/login', '/doc/index', '/verification/index'];
/**
 * to 即将要进入的目标 路由对象
 * from 当前导航正要离开的路由
 * 
 */
router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const token = getToken()
  if (token != null) {
    to.meta.title && store.dispatch('settings/setTitle', to.meta.title)

    /* has token*/
    if (to.path === '/login' || to.path === '/register') {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (store.getters.roles != undefined && store.getters.roles != null && store.getters.roles.length === 0) {
        isRelogin.show = true

        // 判断当前用户是否已拉取完user_info信息
        await store.dispatch('GetInfo').then((res) => {
          isRelogin.show = false
          if (res && res.Success) {
            //有菜单时候生成路由
            store.dispatch('GenerateRoutes', store.getters.menus).then(accessRoutes => {
              // 根据roles权限生成可访问的路由表
              accessRoutes.forEach(route => {
                //判断是否存在相同路由？？？
                if (!isHttp(route.path)) {
                  router.addRoute(route) // 动态添加可访问路由表
                }
              })
              // hack方法 确保addRoutes已完成
              next({ ...to, replace: true })
            })
          }
          else {
            next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
          }
        }).catch(err => {
          store.dispatch('LogOut').then(() => {
            ElMessage.error(err)
            next({ path: '/login' })
          })
        })
      } else {
        next()
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
